
import { useEffect } from 'react';
import './About.css';

// Helper function to preload images
const preloadImages = (imageUrls: string[]) => {
  imageUrls.forEach((url: string) => {
    const img = new Image();
    img.src = url;
  });
};

const education = [
  {
    logo: '/about/harvard.webp',
    title: 'Harvard University',
    subtitle: 'Master in Design Engineering',
  },
  {
    logo: '/about/brown.webp',
    title: 'Brown University',
    subtitle: 'B.S. Computer Science',
  },
];

const work = [
  {
    logo: '/about/nasa.webp',
    title: 'NASA JPL',
    subtitle: 'Data visualization for the Mars Perseverance rover',
  },
  {
    logo: '/about/waymo.webp',
    title: 'Waymo',
    subtitle: 'Simulation for autonomous vehicle development',
  },
  {
    logo: '/about/google.webp',
    title: 'Google',
    subtitle: "Software engineer for Android, Gmail, and Wallet",
  },
];

interface LogoItem {
  logo: string;
  title: string;
  subtitle: string;
}

interface LogoGridProps {
  items: LogoItem[];
}

function LogoGrid({ items }: LogoGridProps) {
  return (
    <div className="logo-grid">
      {items.map((item, idx) => (
        <div className="logo-item" key={idx}>
          <img src={item.logo} alt={item.title} className="logo-img" />
          <div className="logo-caption">
            <div className="logo-title">{item.title}</div>
            <div className="logo-subtitle">{item.subtitle}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function About() {
  // Preload all images when component mounts
  useEffect(() => {
    const allImages = [
      '/about/headshot.webp',
      ...education.map(item => item.logo),
      ...work.map(item => item.logo)
    ];
    preloadImages(allImages);
  }, []);

  return (
    <div className="about">
      <section className="about-hero">
        <img
          src="/about/headshot.webp"
          alt="Headshot"
          className="about-headshot"
        />
        <div className="about-content">
          <div className="about-bio">
            <h1>Hi, I'm Luke.</h1>
            <p>
              I'm a design engineer based in Cambridge, MA.
            </p>
            <br />
            <p>
              I believe the world's most complex challenges can't be solved in silos. I work at the intersection of design, technology, and systems thinking to build human-centered, context-aware solutions. In doing so, I hope to contribute to a more collaborative and thoughtfully designed world.
            </p>
          </div>
        </div>
      </section>

      <section className="about-contact">
        <h2>Let's connect</h2>
        <div>
          For project inquiries and collaborations, you can reach me at: <a href="mailto:luke@lukefiorante.com">luke@lukefiorante.com</a>.
        </div>
      </section>

      <section className="about-path">
        <div className="path-content">
          <h2>Experience & education</h2>
          <div className="path-body">
            My background is in both professional practice and academic research. The following organizations have been central to my work and development.
          </div>
          <div className="path-grid">
            <LogoGrid items={education} />
            <div className="path-divider" />
            <LogoGrid items={work} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default About; 